export const NOTIFICATION_STATUS = {
  info: 'info',
  success: 'success',
  secondarySuccess: 'secondarySuccess',
  warning: 'warning',
  error: 'error',
} as const;

export type NotificationStatus = typeof NOTIFICATION_STATUS[keyof typeof NOTIFICATION_STATUS];
